<template lang="pug">
  div
    a.form-input.c-hand(@click="finderOpened = true" :class="{disabled}")
      span.text-gray(v-if="!value") Selecione o afiliado
      span(v-else) {{ value.person.fullName }}
    finder(v-if="finderOpened" @select="onSelect" @close="finderOpened = false")
</template>

<script>
import Finder from './Finder.vue'

export default {
  props: ['value', 'disabled'],
  components: { Finder },
  data() {
    return {
      finderOpened: false,
    }
  },
  methods: {
    onSelect(filiation) {
      this.model = filiation
      this.finderOpened = false
    },
  },
  computed: {
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
  },
}
</script>

<style lang="stylus" scoped>
a.disabled
  pointer-events none
</style>
